import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import UserBar from '../components/UserBar';
import colors from '../data/colors';
import { device } from '../styled/device';

const Legend = styled.div`

        @media ${device.mobileM} {
            width:100%;
            max-width:100vw;
        }
        @media ${device.laptop} {
            width:70%;
            max-width:50rem;
        }
        /* height:60vh; */
        overflow:scroll;
        margin:0 auto;
        display:flex;
        justify-content:space-between;

        p {
            padding:0.5rem;
            text-align:center;
            font-size: 1rem;
            color:${colors[2]}
            }

`
const UserBarContainer = styled.div`
        height:calc(100vh - 350px);
        overflow:scroll;
        margin:0 auto;

        @media ${device.mobileM} {
            width:100%;
            max-width:100vw;
        }
        
        @media ${device.laptop} {
            width:50%;
            max-width:50rem;
        }


        #legend {

        }
        
        .bar {
            transition: all 0.2s linear, transform 0.1ms linear ;
            border:1px solid ${colors[3]};
            box-sizing:border ;
            padding:1rem;
            border-radius:5px;
            margin:0.5rem 0;
            display:flex;
            align-items:center;
            background-color: ${colors[3]};
            color:black;
            cursor:pointer;
            &:active {
                transform:scale(0.97) ;
            }
            &:hover {
                background-color: ${colors[2]}
            }
            
            &.active {
                &:hover {
                    background-color: ${colors[1]}
                }
                background-color: ${colors[1]};
                /* border:1px solid ${colors[1]}; */
                /* border: 2px solid black; */
                color:white;
            }
            
            span {
                text-align:center;
                font-size:1.2rem;
                /* width: 50%;
                align-self: center; */
            }

            & > span {
                width:40%;
            }
            svg {
                margin:0 auto;
                color: ${colors[4]}
            }

            .profil {
                display:flex;
                flex-direction:column;
            }
            .status {
                width:25%;
                display:flex;
                justify-content:flex-end;
                align-items:center;
                p {
                    width:75%;
                    font-size:1rem;
                    text-align:right;
                }
                & > div {
                    width:25%;
                }
            }
        }
`


function UserBars(props) {
    const [userBarsComps, setuserBarsComps] = useState();
    // const [currentIndex, setCurrentIndex] = useState(0);

    const {allUsers, hasFetched, setIndex, selectIndex, lang} = props

    const handleClick = (index) => {
        setIndex(index)
        // setCurrentIndex(index)
    }
    console.log(selectIndex);

    const ref = useRef()
    useEffect(() => {
        if(hasFetched) {
            const comps = allUsers.map((user,index) => {
                return (
                    <UserBar 
                        lang={lang}
                        key={index} 
                        index={index} 
                        user={user} 
                        handleClick={handleClick}
                        active={index === selectIndex}
                    />
                )
            })
            setuserBarsComps(comps)
        }
    }, [allUsers, selectIndex,lang]);

    // useEffect(() => {
    //     window.addEventListener("keydown", keydownHandler)
    //     // return  () => {
    //     //     window.removeEventListener("keydown",keydownHandler)
    //     // }
    // }, []);

    // const keydownHandler = (e) => {
    //     // console.log(currentIndex)
    //     let direction = e.key === "ArrowUp" ? -1 : e.key === "ArrowDown" ? 1 : 0;
    //     setIndex(selectIndex + direction)
    //     // setCurrentIndex(currentIndex + direction)
    // }

    const handleKeyDown = (e) => {
        console.log(e);
    }
    return (
        <>
            <Legend id="legend">
                <p style={{width:"20%"}}>Name</p>
                <p style={{width:"20%"}}>Result</p>
                <p style={{width:"20%"}}>Trivsel</p>
                <p style={{width:"20%"}}>Status</p>
            </Legend>
            <UserBarContainer onKeyDown={ handleKeyDown } ref={ref}>
                {userBarsComps}
            </UserBarContainer>
        </>
    );
}

export default UserBars;